var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 14.75C29.5312 22.0156 24.1992 28.0508 17.2266 29.1055V18.9688H20.625L21.2695 14.75H17.2266V12.0547C17.2266 10.8828 17.8125 9.76953 19.6289 9.76953H21.4453V6.19531C21.4453 6.19531 19.8047 5.90234 18.1641 5.90234C14.8828 5.90234 12.7148 7.95312 12.7148 11.5859V14.75H9.02344V18.9688H12.7148V29.1055C5.74219 28.0508 0.46875 22.0156 0.46875 14.75C0.46875 6.72266 6.97266 0.21875 15 0.21875C23.0273 0.21875 29.5312 6.72266 29.5312 14.75Z",
    fill: "url(#paint0_linear_7_223)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_223",
    x1: 0,
    y1: 15,
    x2: 30,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7578EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22AAF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.379cf2eb17c811a6e3cd2b12c15ef948.svg";
export { ForwardRef as ReactComponent };